import CourseOverview from './CourseOverview';
import CourseInfo from './CourseInfo';
import CourseSlider from './CourseSlider';
import DisplayModule from './DisplayModule';
import ModuleVideoSlider from './ModuleVideoSlider';
import CourseList from './CourseList';
import CourseItem from './CourseItem';
import {NetworkBenefits} from './NetworkBenefits';

export {
    CourseOverview,
    CourseInfo,
    CourseSlider,
    DisplayModule,
    ModuleVideoSlider,
    CourseList,
    CourseItem,
    NetworkBenefits,
};


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/index.js